<dxc-file-input 
  label="{{ label | translate }}"
  helperText="{{ helperText | translate }}"
  name="name"
  [mode]="mode"
  [minSize]="minSize"
  [maxSize]="maxSize"
  [multiple]="multiple"
  [showPreview]="showPreview"
  [disabled]="disabled"
  [margin]="margin"
  [value]="files"
  accept="accept"
  [tabIndexValue]="tabIndexValue"
  (callbackFile)="onFileInput($event)">
</dxc-file-input>